// Auto-generated per-query builders for ActionOutputParameter
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { ActionOutputParameterReadAPI, ActionOutputParameterWriteAPI, ActionOutputParameterReadAPISchema, ActionOutputParameterWriteAPISchema } from '../types/actionoutputparameter';
import { ModelRegistry } from '../../registries/model-registry';
import { ActionBindsParameter, ActionHasOutputParameters, ActionParameterTypedBy, AtScope, HasAttribute, HasAttributeValue, HasDerivedValue, ItemFlowSourceParameter, Mentions } from '../../relationships/relationship';

import { ItemFlow } from './itemflow';
import { Item } from './item';
import { Action } from './action';
import { SecurityScope } from '../../shared/api/securityscope';
import { Attribute } from './attribute';
import { AttributeValue } from './attributevalue';
import { DerivedValue } from './derivedvalue';
import { Expression } from './expression';





// Builder chain for query: rflp-action-output-parameter-by-id

export interface RflpActionOutputParameterByIdBuilder_0 {
  get(id: string): RflpActionOutputParameterByIdBuilder_1;
  filter(conditions: { id: string }): RflpActionOutputParameterByIdBuilder_1;
}

export interface RflpActionOutputParameterByIdBuilder_1 {
  all(): Promise<ActionOutputParameter[]>;
  first(): Promise<ActionOutputParameter | null>;
  get(): Promise<ActionOutputParameter[]>;
  execute(): Promise<ActionOutputParameter[]>;
}


// Union of all query entry points
export type ActionOutputParameterQueryBuilder = RflpActionOutputParameterByIdBuilder_0;

// Available query names for .setQuery()
export type ActionOutputParameterQueryNames = "rflp-action-output-parameter-by-id";

// Type narrowing for .setQuery()
export type ActionOutputParameterBuilderForQuery<Q extends ActionOutputParameterQueryNames> =
  Q extends "rflp-action-output-parameter-by-id" ? RflpActionOutputParameterByIdBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type ActionOutputParameterInstanceQueryResult<Q extends ActionOutputParameterQueryNames> =
  Q extends "rflp-action-output-parameter-by-id" ? RflpActionOutputParameterByIdBuilder_1
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  '': 'rflp-action-output-parameter-by-id',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends ActionOutputParameterQueryNames>(queryName: Q): ActionOutputParameterBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface ActionOutputParameter extends Partial<ActionOutputParameterReadAPI> {}
export class ActionOutputParameter extends NeoNodeBase<ActionOutputParameterReadAPI, ActionOutputParameterWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "ActionOutputParameter";
  static readonly readSchema = ActionOutputParameterReadAPISchema;
  static readonly writeSchema = ActionOutputParameterWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    attributes: { target: "Attribute", cardinality: "many", isParent: false, relClass: "HasAttribute", direction: "out" },
    attribute_values: { target: "AttributeValue", cardinality: "many", isParent: false, relClass: "HasAttributeValue", direction: "out" },
    derived_values: { target: "DerivedValue", cardinality: "many", isParent: false, relClass: "HasDerivedValue", direction: "out" },
    mentioned_in_expressions: { target: "Expression", cardinality: "many", isParent: false, relClass: "Mentions", direction: "in" },
    item: { target: "Item", cardinality: "one", isParent: false, relClass: "ActionParameterTypedBy", direction: "out" },
    bound_to: { target: "Action", cardinality: "many", isParent: false, relClass: "ActionBindsParameter", direction: "in" },
    owner_action: { target: "Action", cardinality: "one", isParent: true, relClass: "ActionHasOutputParameters", direction: "in" },
    outgoing_flows: { target: "ItemFlow", cardinality: "many", isParent: false, relClass: "ItemFlowSourceParameter", direction: "in" },
  };

  protected get modelName(): string {
    return 'ActionOutputParameter';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return ActionOutputParameter.label;
  }


  constructor(data: Partial<ActionOutputParameterWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: ActionOutputParameterReadAPI, loadContext?: Record<string, any>): ActionOutputParameter {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { item, bound_to, owner_action, outgoing_flows, security_scope, attributes, attribute_values, derived_values, mentioned_in_expressions, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = ActionOutputParameterReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, item: item, bound_to: bound_to, owner_action: owner_action, outgoing_flows: outgoing_flows, security_scope: security_scope, attributes: attributes, attribute_values: attribute_values, derived_values: derived_values, mentioned_in_expressions: mentioned_in_expressions };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return ActionOutputParameter.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'item', 'Item', ModelRegistry);
    loadManyRelationship(processed, 'bound_to', 'Action', ModelRegistry);
    loadManyRelationship(processed, 'owner_action', 'Action', ModelRegistry);
    loadOneRelationship(processed, 'outgoing_flows', 'ItemFlow', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'attributes', 'Attribute', ModelRegistry);
    loadManyRelationship(processed, 'attribute_values', 'AttributeValue', ModelRegistry);
    loadManyRelationship(processed, 'derived_values', 'DerivedValue', ModelRegistry);
    loadManyRelationship(processed, 'mentioned_in_expressions', 'Expression', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new ActionOutputParameter(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): ActionOutputParameterQueryBuilder {
    return new QueryBuilderImpl('ActionOutputParameter').filter(conditions) as any;
  }

  static all(): ActionOutputParameterQueryBuilder {
    return new QueryBuilderImpl('ActionOutputParameter') as any;
  }

  static async first(): Promise<ActionOutputParameter | null> {
    const results = await new QueryBuilderImpl('ActionOutputParameter').execute();
    return results[0] || null;
  }


  static setQuery<Q extends ActionOutputParameterQueryNames>(queryName: Q): ActionOutputParameterBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('ActionOutputParameter');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends ActionOutputParameterQueryNames>(queryName: Q): ActionOutputParameterInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = ActionOutputParameter.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  /**
   * Delete this instance from the server.
   *
   * @param options - Delete options
   * @param options.cascade - Whether to cascade delete related nodes (default: true for most models)
   * @param options.dryRun - If true, return what would be deleted without actually deleting
   * @returns DeleteResult with deleted IDs and count
   *
   * @example
   * ```typescript
   * const actionoutputparameter = await ActionOutputParameter.get(id).first();
   * await actionoutputparameter.delete();  // Delete with default cascade
   *
   * // Or with options
   * const result = await actionoutputparameter.delete({ cascade: false, dryRun: true });
   * console.log('Would delete:', result.deletedIds);
   * ```
   */
  async delete(options: {
    cascade?: boolean;
    dryRun?: boolean;
  } = {}): Promise<{ deletedIds: string[]; count: number }> {
    return this._deleteInstance(options);
  }

  // Relationship manager for 'outgoing_flows' - Python ORM style (cached)
  get outgoing_flows(): RelationshipManager<this, ItemFlow> {
    return this.getOrCreateRelationshipManager('outgoing_flows', () => {
      return new RelationshipManager(this, 'outgoing_flows', 'many', ItemFlowSourceParameter as typeof Relationship);
    });
  }

  // Relationship manager for 'item' - Python ORM style (cached)
  get item(): RelationshipManager<this, Item> {
    return this.getOrCreateRelationshipManager('item', () => {
      return new RelationshipManager(this, 'item', 'one', ActionParameterTypedBy as typeof Relationship);
    });
  }

  // Relationship manager for 'bound_to' - Python ORM style (cached)
  get bound_to(): RelationshipManager<this, Action> {
    return this.getOrCreateRelationshipManager('bound_to', () => {
      return new RelationshipManager(this, 'bound_to', 'many', ActionBindsParameter as typeof Relationship);
    });
  }

  // Relationship manager for 'owner_action' - Python ORM style (cached)
  get owner_action(): RelationshipManager<this, Action> {
    return this.getOrCreateRelationshipManager('owner_action', () => {
      return new RelationshipManager(this, 'owner_action', 'many', ActionHasOutputParameters as typeof Relationship);
    });
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'attributes' - Python ORM style (cached)
  get attributes(): RelationshipManager<this, Attribute> {
    return this.getOrCreateRelationshipManager('attributes', () => {
      return new RelationshipManager(this, 'attributes', 'many', HasAttribute as typeof Relationship);
    });
  }

  // Relationship manager for 'attribute_values' - Python ORM style (cached)
  get attribute_values(): RelationshipManager<this, AttributeValue> {
    return this.getOrCreateRelationshipManager('attribute_values', () => {
      return new RelationshipManager(this, 'attribute_values', 'many', HasAttributeValue as typeof Relationship);
    });
  }

  // Relationship manager for 'derived_values' - Python ORM style (cached)
  get derived_values(): RelationshipManager<this, DerivedValue> {
    return this.getOrCreateRelationshipManager('derived_values', () => {
      return new RelationshipManager(this, 'derived_values', 'many', HasDerivedValue as typeof Relationship);
    });
  }

  // Relationship manager for 'mentioned_in_expressions' - Python ORM style (cached)
  get mentioned_in_expressions(): RelationshipManager<this, Expression> {
    return this.getOrCreateRelationshipManager('mentioned_in_expressions', () => {
      return new RelationshipManager(this, 'mentioned_in_expressions', 'many', Mentions as typeof Relationship);
    });
  }

}
